<div class="empty-table-splash" [ngStyle]="{height: 'calc(100vh - ' + topOffset + 'px)'}">
  <div class="splash-container">
    <div class="icon-container">
      <img class="splash-icon" [src]="'assets/icons/icon-'+ icon +'.svg'" alt="empty-transactions-table-icon" />
    </div>
    <div class="label">{{labelValue}}</div>
  </div>
</div>
